"use client";
import {
  useSelectStore
} from "../__chunks/UG6PMSDE.js";
import "../__chunks/H5NQMD66.js";
import {
  SelectContextProvider
} from "../__chunks/6RJCEQC6.js";
import "../__chunks/VUP7S67H.js";
import "../__chunks/7GWB36ES.js";
import "../__chunks/X3ATWMYX.js";
import "../__chunks/KSMDNUGB.js";
import "../__chunks/7CRP5UGO.js";
import "../__chunks/SNQAYGW2.js";
import "../__chunks/P3UIANB7.js";
import "../__chunks/LFJDOMBA.js";
import "../__chunks/5IIPAC4H.js";
import "../__chunks/XWCMZCWT.js";
import "../__chunks/4ORPOXHX.js";
import "../__chunks/2ID5JPOO.js";
import "../__chunks/6WEF4WY5.js";
import "../__chunks/OZVWZODE.js";
import "../__chunks/2SMRF6AD.js";

// src/select/select-provider.tsx
import { jsx } from "react/jsx-runtime";
function SelectProvider(props = {}) {
  const store = useSelectStore(props);
  return /* @__PURE__ */ jsx(SelectContextProvider, { value: store, children: props.children });
}
export {
  SelectProvider
};
